import { useOverlays } from "contexts/OverlayContext";
import { AddTransactionsModal } from "./AddTransactionsModal";

export const AddTransactionsModalContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("addTransactions");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <AddTransactionsModal show={!overlayIsClosing} onHide={closeOverlay} />
    );
};
